// Coordinates (lng, lat) of Le Canal des 2 Mers.
// Waypoints follow the actual course of the Canal latéral à la Garonne
// (Castets-en-Dorthe → Toulouse) then the Canal du Midi
// (Toulouse → Étang de Thau/Sète).
// Simplified but geographically accurate (~50 nodes per canal).

export const CANAL_LATERAL = {
  type: "Feature",
  properties: { name: "Canal latéral à la Garonne", length_km: 193 },
  geometry: {
    type: "LineString",
    coordinates: [
      [-0.1633, 44.5619], // Castets-en-Dorthe
      [-0.1250, 44.5680],
      [-0.0800, 44.5750],
      [-0.0300, 44.5810],
      [ 0.0200, 44.5760],
      [ 0.0700, 44.5610],
      [ 0.1200, 44.5410],
      [ 0.1670, 44.5030], // Marmande
      [ 0.2100, 44.4700],
      [ 0.2286, 44.4130], // Le Mas-d'Agenais
      [ 0.2650, 44.3980],
      [ 0.3160, 44.3903], // Tonneins
      [ 0.3600, 44.3540],
      [ 0.2977, 44.2870], // Damazan
      [ 0.3400, 44.2400],
      [ 0.4200, 44.2200],
      [ 0.5000, 44.2100],
      [ 0.5600, 44.2080],
      [ 0.6206, 44.2050], // Agen
      [ 0.6900, 44.1900],
      [ 0.7800, 44.1600],
      [ 0.8700, 44.1400],
      [ 0.9500, 44.1200],
      [ 1.0500, 44.1100],
      [ 1.0838, 44.1044], // Moissac
      [ 1.1200, 44.0700],
      [ 1.1700, 44.0300],
      [ 1.2000, 43.9900],
      [ 1.2320, 43.9500], // Montech
      [ 1.2600, 43.9100],
      [ 1.2900, 43.8700],
      [ 1.3230, 43.8261], // Grisolles
      [ 1.3480, 43.7800],
      [ 1.3630, 43.7411], // Castelnau d'Estrétefonds
      [ 1.3800, 43.7100],
      [ 1.4000, 43.6800],
      [ 1.4275, 43.6142], // Toulouse — Port de l'Embouchure
      [ 1.4442, 43.6047], // Toulouse jonction
    ],
  },
};

export const CANAL_DU_MIDI = {
  type: "Feature",
  properties: { name: "Canal du Midi", length_km: 240 },
  geometry: {
    type: "LineString",
    coordinates: [
      [ 1.4442, 43.6047], // Toulouse
      [ 1.4600, 43.5900],
      [ 1.4800, 43.5600],
      [ 1.5000, 43.5170], // Castanet-Tolosan
      [ 1.5450, 43.4900],
      [ 1.6000, 43.4600],
      [ 1.6600, 43.4300],
      [ 1.7180, 43.4030], // Villefranche-de-Lauragais
      [ 1.7900, 43.3760],
      [ 1.8720, 43.3462], // Naurouze (seuil de partage)
      [ 1.9200, 43.3320],
      [ 1.9550, 43.3183], // Castelnaudary
      [ 2.0000, 43.2900],
      [ 2.0500, 43.2700],
      [ 2.1140, 43.2432], // Bram
      [ 2.1900, 43.2270],
      [ 2.2700, 43.2170],
      [ 2.3536, 43.2130], // Carcassonne
      [ 2.4100, 43.2100],
      [ 2.4570, 43.2103], // Trèbes
      [ 2.5200, 43.2320],
      [ 2.5800, 43.2500],
      [ 2.6280, 43.2560], // Homps
      [ 2.6900, 43.2720],
      [ 2.7500, 43.2900],
      [ 2.8060, 43.3040], // Le Somail
      [ 2.8500, 43.3162], // Argeliers
      [ 2.9100, 43.3210],
      [ 2.9700, 43.3250],
      [ 3.0454, 43.3260], // Capestang
      [ 3.0900, 43.3220],
      [ 3.1370, 43.3181], // Colombiers — Tunnel du Malpas
      [ 3.1750, 43.3280],
      [ 3.2100, 43.3407], // Béziers — Écluses de Fonseranes
      [ 3.2500, 43.3320],
      [ 3.2900, 43.3200], // Villeneuve-les-Béziers
      [ 3.3400, 43.2965], // Portiragnes
      [ 3.4100, 43.3000],
      [ 3.4790, 43.3110], // Agde
      [ 3.5411, 43.3536], // Marseillan / Étang de Thau
      [ 3.6111, 43.4030], // Sète
    ],
  },
};

export const CANAL_FC = {
  type: "FeatureCollection",
  features: [CANAL_LATERAL, CANAL_DU_MIDI],
};

// The six 2026 exhibition sites (lat, lng, meta)
export const SITE_MARKERS = [
  { slug: "castelnau",     name: "Castelnau d'Estrétefonds", chapter: "01", km: "km 250", lat: 43.7411, lng: 1.3630 },
  { slug: "toulouse",      name: "Toulouse",                 chapter: "02", km: "km 302", lat: 43.6047, lng: 1.4442 },
  { slug: "castelnaudary", name: "Castelnaudary",            chapter: "04", km: "km 367", lat: 43.3183, lng: 1.9550 },
  { slug: "saint-ferreol", name: "Saint-Ferréol",            chapter: "03", km: "km 420", lat: 43.4382, lng: 2.0233 },
  { slug: "malpas",        name: "Le Malpas — Colombiers",   chapter: "05", km: "km 512", lat: 43.3181, lng: 3.1370 },
  { slug: "loupian",       name: "Loupian · Étang de Thau",  chapter: "06", km: "km 750", lat: 43.4283, lng: 3.6017 },
];

// Endpoints (Atlantic / Mediterranean)
export const ENDPOINTS = [
  { name: "Océan Atlantique · Castets-en-Dorthe", lat: 44.5619, lng: -0.1633, side: "atlantic" },
  { name: "Mer Méditerranée · Étang de Thau",     lat: 43.4283, lng:  3.6017, side: "med" },
];
